import api from "../../config/api";

const state = {
    changePasswordResponse:''
}
const mutations = {
    SET_CHANGE_PASSWORD(state, payload) {
        state.changePasswordResponse = payload;
    },
}

const actions = {

    async changePassword({ commit }, newpassword) {      

        try {
            await api.post(`/manageuserajax`, {
                cmd: "changepassword",
                password: newpassword,
            })
                .then((response) => {
                    commit('SET_CHANGE_PASSWORD', response.data);
                })
                .catch((error) => {
                    console.log("Error in fetching data", error);
                });
        } catch (error) {
            console.error('Error fetching API data:', error);
        }
    },

}

const getters = {
    stChangePasswordResponse: state => state.changePasswordResponse,
}

export default {
    state,
    mutations,
    actions,
    getters
}